<template lang="pug">
    layout

        // Title
        title-component(title="Change Payment" slot="title")

        // Payment form
        payment-form

</template>

<script>
    import Layout from '../../Dashboard/Layout';
    import VueTypes from 'vue-types';
    import Logo from '~components/Logo';
    import Separator from '~components/Separator';
    import Title from '~components/Title';
    import PaymentForm from './PaymentForm';
    import { isAndroid } from '~services';
    import { mapActions } from 'vuex';

    export default {
        components: {
            Layout,
            PaymentForm,
            LogoComponent: Logo,
            SeparatorComponent: Separator,
            TitleComponent: Title
        },
        props: {
            packageType: VueTypes.string.def('')
        },
        created() {
            // Play Payments policy: card management is web-only on Android.
            if (isAndroid()) {
                this.$router.push({ name: 'dashboard.themes' });
                return;
            }
            this.getCards();
        },
        methods: {
            ...mapActions('payments', ['getCards'])
        }
    };
</script>
